import { render, staticRenderFns } from "./LocalMemes.vue?vue&type=template&id=e89d7270&"
import script from "./LocalMemes.vue?vue&type=script&lang=js&"
export * from "./LocalMemes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports